import { render, staticRenderFns } from "./my-pagination.vue?vue&type=template&id=31d2a9c5&scoped=true&"
import script from "./my-pagination.vue?vue&type=script&lang=js&"
export * from "./my-pagination.vue?vue&type=script&lang=js&"
import style0 from "./my-pagination.vue?vue&type=style&index=0&id=31d2a9c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2a9c5",
  null
  
)

export default component.exports